(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["card-gallery"] && !Shopify.designMode) return;
  try {
    const initCardGalleryProgress = () => {
    if (!window.matchMedia('(max-width: 749px)').matches) return;

    document.querySelectorAll('.card-gallery').forEach((gallery) => {
      const slideshow = gallery.querySelector('slideshow-component');
      const slides = gallery.querySelectorAll('slideshow-slide');

      if (!slideshow || slides.length <= 1) return;
      if (gallery.querySelector('.card-gallery__mobile-progress')) return;

      const progress = document.createElement('div');
      progress.className = 'card-gallery__mobile-progress';

      const fill = document.createElement('span');
      fill.className = 'card-gallery__mobile-progress-fill';

      progress.appendChild(fill);
      gallery.appendChild(progress);

      const updateProgress = () => {
        let activeIndex = 0;

        slides.forEach((slide, index) => {
          if (slide.getAttribute('aria-hidden') === 'false') {
            activeIndex = index;
          }
        });

        fill.style.width = `${((activeIndex + 1) / slides.length) * 100}%`;
      };

      const observer = new MutationObserver(() => {
        updateProgress();
      });

      slides.forEach((slide) => {
        observer.observe(slide, {
          attributes: true,
          attributeFilter: ['aria-hidden']
        });
      });

      updateProgress();
    });
  };

  document.addEventListener('DOMContentLoaded', initCardGalleryProgress);
  window.addEventListener('load', initCardGalleryProgress);
  } catch(e) { console.error(e); }
})();

})();
